import React from 'react';
import PropTypes from 'prop-types';
import { ContentCard } from '@cdm/quickenloans-library/lib';

import GridCard from './GridCard';
import {testAttributes} from './Constants';
import * as styles from './PostGrid.module.scss';

const fnListCards = (posts, postLimit) =>
    posts?.slice(0, postLimit).map((node) => (
        <li className={styles.gridElement} key={`grid-cell-${node.databaseId}`}>
            <ContentCard className={`${!node?.gatsbyImage && !node?.imgPath ? styles.heightAuto : styles.heightFull} ${styles.contentCard}`}>
                <GridCard 
                    title={node?.title}
                    minutes={node?.readingtime} 
                    featuredImage={node?.gatsbyImage?.localFile?.childImageSharp.data}
                    imgPath={node?.imgPath}
                    imgAlt={node?.imgAltText} 
                    href={node?.link}
                    isPinned={node?.pinned || false}
                    id={node?.databaseId}
                /> 
            </ContentCard>
        </li>
    )); 


const PostGrid = ({ posts, postLimit = 12, className }) => (
    <ul
        className={`${styles.gridBase} ${styles[`gridCount${postLimit}`]} ${className || ''}`}
        data-testid={testAttributes.POST_GRID}
    >
        {fnListCards(posts, postLimit)}
    </ul>
);

PostGrid.propTypes = {
    /** Number of post in a row, cannot be greater than count of posts */
    postLimit: PropTypes.number,
    /** List of post elements */
    posts: PropTypes.arrayOf(PropTypes.object).isRequired,
    /** Additional class names */
    className: PropTypes.string,
};

export default PostGrid;